/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getIntegrationTemplates } from 'app/entities/integration-template/integration-template.reducer';
import { createEntity, getEntity, reset, updateEntity } from './tenant-integration-template.reducer';

export const TenantIntegrationTemplateUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const integrationTemplates = useAppSelector(state => state.integrationTemplate.entities);
  const tenantIntegrationTemplateEntity = useAppSelector(state => state.tenantIntegrationTemplate.entity);
  const loading = useAppSelector(state => state.tenantIntegrationTemplate.loading);
  const updating = useAppSelector(state => state.tenantIntegrationTemplate.updating);
  const updateSuccess = useAppSelector(state => state.tenantIntegrationTemplate.updateSuccess);

  const handleClose = () => {
    navigate(`/tenant-integration-template${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getIntegrationTemplates({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tenantIntegrationTemplateEntity,
      ...values,
      template: integrationTemplates.find(it => it.id.toString() === values.template?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...tenantIntegrationTemplateEntity,
          template: tenantIntegrationTemplateEntity?.template?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.tenantIntegrationTemplate.home.createOrEditLabel" data-cy="TenantIntegrationTemplateCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.home.createOrEditLabel">
              Create or edit a TenantIntegrationTemplate
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tenant-integration-template-id"
                  label={translate('tinyMedicRestApp.tenantIntegrationTemplate.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.messageFormat')}
                id="tenant-integration-template-messageFormat"
                name="messageFormat"
                data-cy="messageFormat"
                type="text"
              />
              <UncontrolledTooltip target="messageFormatLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.messageFormat" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.active')}
                id="tenant-integration-template-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.cursor')}
                id="tenant-integration-template-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.lastUpdated')}
                id="tenant-integration-template-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.microSec')}
                id="tenant-integration-template-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.timestampEntry')}
                id="tenant-integration-template-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tenantIntegrationTemplate.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tenant-integration-template-template"
                name="template"
                data-cy="template"
                label={translate('tinyMedicRestApp.tenantIntegrationTemplate.template')}
                type="select"
              >
                <option value="" key="0" />
                {integrationTemplates
                  ? integrationTemplates.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/tenant-integration-template" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TenantIntegrationTemplateUpdate;
